import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { HttpClient, HttpClientProvider, Toaster } from '@/shared';
import { getEnvironmentConfig } from '../../application/config/environment';
import { store, persistor } from '@/shared/infra/store';
import { AppDIProvider } from './AppDIProvider';

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  const config = getEnvironmentConfig();

  const httpClientCore = new HttpClient({
    baseURL: config.apiBaseUrlCore,
    timeout: 100000,
    defaultHeaders: {
      'Content-Type': 'application/json',
    },
  });

  const httpClientIntegration = new HttpClient({
    baseURL: config.apiBaseUrlIntegration,
    timeout: 100000,
    defaultHeaders: {
      'Content-Type': 'application/json',
    },
  });

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <HttpClientProvider httpClientCore={httpClientCore} httpClientIntegration={httpClientIntegration}>
          <AppDIProvider>{children}</AppDIProvider>
          <Toaster />
        </HttpClientProvider>
      </PersistGate>
    </Provider>
  );
};
